<mat-icon [id]="id" [class]="iconClass" [ngStyle]="{ 'width': iconWidth+'px', 'height': iconHeight+'px' }">
  <ng-content></ng-content>
</mat-icon>
